import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=ce7d7534&"
import script from "./DashboardList.vue?vue&type=script&lang=js&"
export * from "./DashboardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DashboardList.vue"
export default component.exports